import styled from 'styled-components';
import Colors from '@/constants/Colors';
import { studentTopbarHeight } from './StudentPageTopbar/StudentPageTopbar.styled';
import { StyledGlobals } from 'styles/globals.styled';
import { pxToVw } from '@/modules/styled/cssUnits';

export const defaultPagePadding = pxToVw(30);

export const StyledStudentPage = styled(StyledGlobals)`
  background: ${Colors.backgroundPaleBlue};
  overflow-y: auto;

  .main-layout {
    .content-layout {
      .page-content {
        height: calc(var(--appheight) - ${studentTopbarHeight});
        position: relative;
        margin: 0px;
        display: flex;
        flex-direction: column;
      }
    }

    h1 .ant-breadcrumb {
      font-weight: bold;
    }
  }
`;
